var helper = require('../../helper');
var ToastrController = new (require('../../services/ToastrController'));

var TicketCalendarController = function() {
    var self = this; // Needed for using all constructor variables inside this function, note the difference -> no "this" but "var" at the beginning
}

TicketCalendarController.prototype.changeBookInDates = function(event, calendar) {

	console.log('changeBookInDates');
	// console.log(event);
	// console.log('start');
	// console.log(event.start);
	// console.log('end');
	// console.log(event.end);

	var start = (event.start) ? event.start.format("DD/MM/YYYY HH:mm") : null,
		end = (event.end) ? event.end.format("DD/MM/YYYY HH:mm") : null;

    /** Add event when dropped */
	$.ajax({
		url: '/api/tickets/change/book-in-dates',
		data: {
			start: start,
			end: end,
			id: event.id
		},
		type: 'POST',
		dataType: 'json',
		success: function (response) {
			var ticket = response.ticket;
			// calendar.fullCalendar('renderEvent', ticket, true); // only for change DAY, not RESIZE
			$('#unassigned-ticket-'+ticket.id).remove();
		},
		error: function (e) {
			console.log('Error' + e);
		}
	});

}

TicketCalendarController.prototype.deleteModel = function(CalendarController, EditModalFormController, ticketId) {

    var self = this;

    $.ajax(
        {
            type: 'POST',
            data: ticketId,
            url: helper.getOrigin() + "/api/tickets/delete/" + ticketId,
            dataType: 'json',

            success: function(data) {
                EditModalFormController.clearModal();
                EditModalFormController.closeModal();
                if (data.status == 'error') {
                    ToastrController.showDanger(data.message);
                } else {
                    ToastrController.showSuccess(data.message);
                    CalendarController.render();
                }

            },

            error: function(data) {
                ToastrController.showDanger(data.message);
            }
        });

}

TicketCalendarController.prototype.filterUnassignedTicketByContact = function(filterContactSelect) {

	var $filterContactSelect = $(filterContactSelect),
			contactId = $filterContactSelect.val(),
			$unassignedTickets = $('.event-in-filter'),
			$unAssignedTicketByContractor = $('.event-in-filter[data-contact-id="'+contactId+'"]');

	// hide all
	$unassignedTickets.hide();

	if(contactId == 0){  // if 0 -> show all

		$unassignedTickets.show();

	} else if(contactId == -1){ // if -1 -> show unassigned

		$('.event-in-filter[data-contact-id=""]').show();

	} else{ // else -> show chosen

		$unAssignedTicketByContractor.show();
	}

}

TicketCalendarController.prototype.generateDraggableTickets = function() {

	$('div.event-in-filter').each(function () {

		// it doesn't need to have a start or end
		var eventObject = {
			title: $.trim($(this).text()) // use the element's text as the event title
		};

		// store the Event Object in the DOM element so we can get to it later
		$(this).data('eventObject', eventObject);

		// make the event draggable using jQuery UI
		$(this).draggable({
			//		zIndex: 999,
			revert: true, // will cause the event to go back to its
			revertDuration: 0 // original position after the drag
		});
	});
}

TicketCalendarController.prototype.getModel = function(modelId, callbackSuccess) {

    $.ajax({
        type: 'POST',
        url: helper.getOrigin() + "/api/tickets/get-for-calendar" ,
        data: { 'id' : modelId },
        // dataType: 'json',

        success: function(data) {
            // console.log(data);
            callbackSuccess(data);
        },

        error: function (data) {
        }
    });
}

TicketCalendarController.prototype.getFormData = function(unindexed_array) {

    var indexed_array = {};

    $.map(unindexed_array, function(n, i){
        indexed_array[n['name']] = n['value'];
    });

    return indexed_array;
}

TicketCalendarController.prototype.renderEventWithContractorInformation = function(event, element) {
	element.find('.fc-list-item-time').html(event.ticket_status)
	element.find('.fc-list-item-title').append('<div>Contractor Contact: ' + event.contractor_user + '</div><div>' + event.calendar_description + '</div>');
	element.find('.fc-content').append('<div>Contractor Contact: ' + event.contractor_user + '</div><div>' + event.calendar_description + '</div>');
}

TicketCalendarController.prototype.updateModel = function(CalendarController, EditModalFormController) {

    var self = this;

    var serializedData = EditModalFormController.getFieldsData();

    $.ajax(
        {
            type: 'POST',
            data: serializedData,
            url: helper.getOrigin() + "/api/tickets/update-from-calendar/" + self.getFormData(serializedData).id,
            dataType: 'json',

            success: function (data) {
                EditModalFormController.clearModal();
                EditModalFormController.closeModal();
                if (data.status == 'error') {
                    ToastrController.showDanger(data.message);
                } else {
                    ToastrController.showSuccess(data.message);
                    CalendarController.render();
                }
            },

            error: function (data) {

                var errors = data.responseJSON;

                // Now display all errors from validation
                EditModalFormController.displayErrors(errors);

            }
        });

}


module.exports = TicketCalendarController;